import { Dialog } from "@ui/components/Dialog";

import { Button } from "@jti/core-components/components/Button";

import type { DeviceContentGateProps } from "../../DeviceContentGate";

import styles from "./DeviceContentGatePopup.module.scss";

export type DeviceContentGatePopupProps = {
  isOpen: boolean;
  onConfirm: () => void;
  onDecline: () => void;
} & Pick<DeviceContentGateProps, "limitationText" | "confirmText" | "declineText" | "isAuthorMode">;

export const DeviceContentGatePopup = ({
  isOpen,
  limitationText,
  confirmText,
  declineText,
  onConfirm,
  onDecline,
  isAuthorMode = false,
}: DeviceContentGatePopupProps) => {
  if (!isOpen) {
    return null;
  }

  return (
    <Dialog
      isOpened={isOpen}
      closable={false}
      dataTestId="deviceContentGate"
      withContentPadding={false}
      isUnwrapped={isAuthorMode}
      ariaLabelledBy="limitationText"
    >
      <div className={styles.container}>
        <div className={styles.content}>
          <p className={styles.description} id="limitationText">
            {limitationText}
          </p>
        </div>
        <div className={styles.ctaContainer}>
          <Button variant="primary" onClick={onConfirm}>
            {confirmText}
          </Button>
          <Button variant="secondary" onClick={onDecline}>
            {declineText}
          </Button>
        </div>
      </div>
    </Dialog>
  );
};
